import { Component } from 'preact'
// eslint-disable-next-line import/no-internal-modules
import MultiSelectionTagField from '@insided/deprecated-preact-components/design-system-components/multi-selection-tag-field'
// eslint-disable-next-line import/no-internal-modules
import InputGroup from '@insided/deprecated-control/ui-components/InputGroup'
// eslint-disable-next-line import/no-internal-modules
import SearchBox from '@insided/deprecated-preact-components/search-box/SearchBox'
// eslint-disable-next-line import/no-internal-modules
import Icon from '@insided/deprecated-preact-components/assets'

export interface TaglikeDropdownItem {
  id: string | number
  value: string | number
  name: string
}

export interface TaglikeDropdownProps {
  label: string
  placeholder: string
  id?: string
  isSearchable?: boolean
  items: TaglikeDropdownItem[]
  selectedItems: TaglikeDropdownItem[]
  onCheck: (item: TaglikeDropdownItem) => void
  onUncheck: (item: TaglikeDropdownItem) => void
}

interface State {
  showItems: boolean
  filterValue: string
}

class TaglikeDropdown extends Component<TaglikeDropdownProps, State> {
  wrapperRef: null | HTMLElement = null

  state = {
    showItems: false,
    filterValue: ''
  }

  addHandler = (e: MouseEvent) => {
    const { showItems } = this.state
    if (showItems) {
      return
    }

    e.stopPropagation()

    this.setState(
      { showItems: true },
      () => window.document.addEventListener('click', this.handleClickOutside)
    )
  }

  removeHandler = () => {
    window.document.removeEventListener('click', this.handleClickOutside)
    this.setState({ showItems: false })
  }

  handleClickOutside = (e: MouseEvent) => {
    const { showItems } = this.state
    if (!this.wrapperRef || !showItems) {
      return
    }

    if (!this.wrapperRef.contains(e.target as HTMLElement)) {
      e.stopPropagation()
      this.removeHandler()
    }
  }

  render() {
    const {
      id,
      label,
      placeholder,
      items,
      selectedItems,
      isSearchable = true,
      onCheck,
      onUncheck
    } = this.props
    const { showItems, filterValue } = this.state

    return (
      <div
        className='taglike-dropdown-wrapper'
      >
        <MultiSelectionTagField
          id={id ?? 'taglike-dropdown'}
          onClick={this.addHandler}
          label={label}
          pills={selectedItems.map(item => item.name)}
          onPillClick={(pill) => {
            const itemClicked = selectedItems.find(item => item.name === pill)

            if (itemClicked) {
              onUncheck(itemClicked)
            }
          }}
          isControl
          dropdown={!selectedItems.length && (
            <div className='placeholder'>
              <span>{placeholder}</span>
              <Icon icon='chevronDown' />
            </div>
          )}
        />
        {showItems && (
          <div className='selector-dropdown' ref={node => { this.wrapperRef = node }}>
            <div className='selector-dropdown-content'>
              {isSearchable && (
                <SearchBox
                  isModerationOverview
                  placeholder='Search'
                  value={filterValue}
                  onSubmit={() => {}}
                  onInput={(e) => this.setState({ filterValue: (e.target as HTMLInputElement).value })}
                  onClear={() => this.setState({ filterValue: '' })}
                />
              )}
              <div className='selector-items'>
                {items.filter(item => item.name.toLowerCase().includes(filterValue.toLowerCase())).map(item => {
                  const { id, name, value } = item
                  const checked = !!selectedItems.find(selectedItem => selectedItem.id === id)

                  return (
                    <InputGroup
                      key={`item-${id}`}
                      inline
                      type='checkbox'
                      value={value}
                      title={name}
                      checked={checked}
                      onChangeCheckbox={() => checked ? onUncheck(item) : onCheck(item)}
                    />
                  )
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default TaglikeDropdown
